/**
 * Brandner Toast Notifications
 *
 * Zeigt nicht-blockierende Toast-Benachrichtigungen statt nativer alert()-Dialoge.
 * Wird in beide Bundles (auction-page + auction-loop) importiert,
 * damit showBidToast() ueberall verfuegbar ist.
 */
(function($) {
    'use strict';

    function showBidToast(message, type) {
        type = type || 'info';
        var $toast = $('<div class="brandner-bid-toast toast-' + type + '">' + message + '</div>');

        // Inline-Styles pro Typ (cache-unabhängig, damit Toast sofort korrekt dargestellt wird)
        var styles = {
            error:   { bg: '#fef2f2', color: '#991b1b', border: '2px solid #fca5a5' },
            success: { bg: '#22c55e', color: 'white',   border: 'none' },
            warning: { bg: '#f97316', color: 'white',   border: 'none' },
            info:    { bg: '#3b82f6', color: 'white',   border: 'none' }
        };
        var s = styles[type] || styles.info;
        $toast.css({ 'background-color': s.bg, 'color': s.color, 'border': s.border });

        $('body').append($toast);

        // Animation: Einblenden
        setTimeout(function() {
            $toast.addClass('show');
        }, 10);

        // Nach 4 Sekunden ausblenden
        setTimeout(function() {
            $toast.removeClass('show');
            setTimeout(function() {
                $toast.remove();
            }, 300);
        }, 4000);

        console.log('[BrandnerToast] ' + type + ' - ' + message);
    }

    // Globale Funktion fuer externe Nutzung
    window.showBidToast = showBidToast;

})(jQuery);
